module.exports = __webpack_public_path__ + "json/market0-0.json?8d5fdc07fd64821fbe38157e1ba6ded2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market0-0.json
// module id = 1251
// module chunks = 3